import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from 'styled-components';
import CodeBlock from './codeblock';

export const ThemeValues = ({ themeKey = '' }) => {
    const theme = useContext(ThemeContext);
    const themeScale = theme[themeKey];
    return <CodeBlock>{themeKey + ' = ' + JSON.stringify(themeScale, null, 4)}</CodeBlock>;
};
ThemeValues.propTypes = {
    themeKey: PropTypes.string,
};

export default ThemeValues;
